import fifthaveClient, { fifthUrl } from './fifthaveClient';
import bxlUtils from 'bxl-utils'

export function getProduct(productId, promo = true, groupBuy = false) {
    return fifthaveClient.get(`/api/v1/products/${productId}`, {
        params: { promo, groupBuy }
    });
}

export function getProductsCnName(data) {
    return fifthaveClient.post(`/api/v1/products/_batch/load-title`, data);
}

export function changeProductsName(data) {
    return fifthaveClient.post(`/api/v1/products/_batch/title`, data);
}

export function productImagesSort(id, data) {
    return fifthaveClient.post(`/api/v1/products/${id}/images/_sort`, data);
}

export function pinnedHistory(productId) {
    return fifthaveClient.get(`/api/v1/_internal/auditactions/fifthave.product_manual/${productId}`)
}

export function discoverV2(queryParams: any, cancelTokenSource?: any) {
    return fifthaveClient.get('/api/v2/discover', {
        params: queryParams,
        cancelToken: cancelTokenSource?.token,
        paramsSerializer: params => {
            return bxlUtils.uri.stringify(params)
        }
    })
}

export function discoverV2Download(queryParams: any) {
    return fifthaveClient.get('/api/v2/discover/_download', {
        params: queryParams,
        paramsSerializer: params => {
            return bxlUtils.uri.stringify(params)
        }
    })
}

export function uploadProductImage(formData: FormData, onProgress) {
    return fifthaveClient.post('/api/v1/images', formData, {
        onUploadProgress: (processEvent: any) => {
            const { total, loaded } = processEvent
            onProgress && onProgress(total, loaded)
        }
    })
}

export function updateImageText(productIds: string[], imageText: any) {
    return fifthaveClient.post('api/v1/products/_batch', {
        productIds,
        update: { imageText }
    })
}

export function getProductCategories() {
    return fifthaveClient.get('api/v2/productcategories')
}

export function getProductCategory(categoryId: string) {
    return fifthaveClient.get(`api/v1/productcategories/${categoryId}`)
}

export function getExtimatedProductPrice(productId: string, shippingMethod: string) {
    return fifthaveClient.get(`api/v1/product/estimate/one-price/${productId}/_lowest?sm=${shippingMethod}&explain=true`)
}

export function getProductDetail(productId: string) {
    return fifthaveClient.get(`api/v1/products/${productId}/_internal`, {
        params: {
            promo: false,
            pinInfo: false,
        }
    })
}

export function modifyName(body: any) {
    return fifthaveClient.post(`api/v1/products/_batch/manual/name-cn`, body)
}

export function modifyCate(pId: string, cId: any) {
    return fifthaveClient.post(`api/v1/products/${pId}/manual`, { 'categoryIds': cId })
}

export function getModifyNameHistory(id: string) {
    return fifthaveClient.get(`/api/v1/products/${id}/manual/name-cn`)
}

export function getExplainRewrite(q: string, cancelTokenSource?: any) {
    // dogfood domain not work
    return fifthaveClient.get(`https://5thave-prod.bieyangapp.com/api/v1/basic-data/_internal/forward/catalog/catalog/api/rewrite/explain`, {
        cancelToken: cancelTokenSource?.token,
        params: {
            q,
            expl: 2, // explainLevel
            nocache: true
        }
    })
}

export const uploadImageAction = `${fifthUrl}/api/v1/images`


export const getProductInfo = (productId: string) => {
    return fifthaveClient.get(`/api/v1/products/${productId}`, {
      params: {
        skuInfo : false
      },
    })
}

export const getMarkUpPolicies = (id) => fifthaveClient.get(`/api/v1/_internal/mark-up-policies/${id}`)


export const operateTagsToSkus = params => fifthaveClient.patch('api/v1/products/_batch/skus/tags', params)
